(function () {
  'use strict';

  // Static retailer data: [name, city, state]
  var RAW = [["Andy's Garden Center","Birmingham","AL"],["Botanica Gardens","Little Rock","AR"],["Berridge Nurseries, Inc.","Phoenix","AZ"],["Desert Horizon Nursery","Queen Creek","AZ"],["Harlow Gardens","Tucson","AZ"],["Armstrong Garden Centers","Southern California","CA"],["Drake House","Ventura","CA"],["Fabbri Statuary","American Canyon","CA"],["Griggs Nursery","Carmel-By-The-Sea","CA"],["High-Hand Nursery","Loomis","CA"],["Magnolia Gift and Garden","Chico","CA"],["Merrihew's Sunset Gardens","Santa Monica","CA"],["Pottery World","Rocklin","CA"],["Riverside Nursery","Fresno","CA"],["Shop Around the Corner","El Cajon","CA"],["Sloat Gardens","Petaluma","CA"],["Terra Sol Garden Center","Santa Barbara","CA"],["The Potting Shed by Carlisle","Orange","CA"],["Walter Andersen Nursery","San Diego","CA"],["Waterlilies","Oakland","CA"],["Welcome Haight & Ashbury","San Francisco","CA"],["West End Nursery","San Rafael","CA"],["Yerba Buena Nursery","Half Moon Bay","CA"],["Artisan Center","Denver","CO"],["City Floral Greenhouse","Denver","CO"],["Country Fair Garden Center","Denver","CO"],["Echter's Greenhouse","Arvada","CO"],["Tagawa Gardens","Centennial","CO"],["The Windsor Gardener","Windsor","CO"],["This Place is for the Birds","Colorado Springs","CO"],["Urban Garden","Louisville","CO"],["Garden Specialties","Mystic","CT"],["The Gardener's Center","Darien","CT"],["Edison Ford Winter Estates","Fort Myers","FL"],["Home & Garden Treasures","Mount Dora","FL"],["Island Home Garden Center","Tavernier","FL"],["Native Nurseries","Tallahassee","FL"],["Treehouse Gallery","St. Petersburg","FL"],["Atlanta Botanical Garden","Atlanta","GA"],["Garden on the Square","Savannah","GA"],["Mark of the Potter","Clarkesville","GA"],["Pane in the Glass","Saint Simons Island","GA"],["Culver's Garden Center & Greenhouse","Marion","IA"],["Dubuque Arboretum & Botanical Gardens","Dubuque","IA"],["Seed Savers Exchange","Decorah","IA"],["Stam Garden Center","Oskaloosa","IA"],["Ted Lare Design Build & Garden Center","Cumming","IA"],["Franz Witte Garden Center","Nampa","ID"],["Moss Greenhouses","Jerome","ID"],["New Leaf Nursery","Hayden","ID"],["Town & Country Gardens","Idaho Falls","ID"],["Farmers Market Garden Center","Chicago","IL"],["Honey Bee Gardens Farm","Downers Grove","IL"],["Hortons Home Lighting","La Grange","IL"],["Luur's","Hillside","IL"],["Prairie Gardens","Champaign","IL"],["That Perennial Place","Morris","IL"],["Wannemaker's","Downers Grove","IL"],["Wild Birds Unlimited","Palos Park","IL"],["The Family Tree Nursery","Overland Park","KS"],["Frank Otte Nursery & Garden Center","Louisville","KY"],["Jackson's Orchard & Nursery","Bowling Green","KY"],["Mahonia Studio","Louisville","KY"],["Andrew's Greenhouse","Amherst","MA"],["Soares Nursery and Landscape","East Falmouth","MA"],["Surreybrooke","Middletown","MD"],["Revelations","Ogunquit","ME"],["Sprague's Nursery","Bangor","ME"],["Weston's Farm and Markets","Fryeburg","ME"],["Allemons Landscape Center","Detroit","MI"],["Bayside Gallery","Suttons Bay","MI"],["Countryside Greenhouse","Allendale","MI"],["Deneweth's Garden Center","Macomb","MI"],["English Gardens","Clinton Township","MI"],["English Gardens","Plymouth","MI"],["English Gardens","Royal Oak","MI"],["English Gardens","West Bloomfield","MI"],["English Gardens","Dearborn Heights","MI"],["English Gardens","Eastpointe","MI"],["Hessell's Greenhouse","Shelby Twp","MI"],["Jonker's Garden","Holland","MI"],["Ray Wiegand's Nursery","Macomb","MI"],["Secret Garden","Empire","MI"],["Sturgeon River Pottery","Petoskey","MI"],["Fluegel's Farm, Garden & Pet","Rosemount","MN"],["General Store of Minnesota","Minnetonka","MN"],["Minnesota Landscape Arboretum","Chanhassen","MN"],["Mother Earth Gardens","Minneapolis","MN"],["Pahl's Market","Apple Valley","MN"],["Rose & Floral Greenhouse","Stillwater","MN"],["Sargent's Nursery","Red Wing","MN"],["Woods' Seed & Nursery","Waite Park","MN"],["Suburban Lawn & Garden","Kansas City","MO"],["Three Trees Workshop","Warrensburg","MO"],["Timberwinds Nursery","Ellisville","MO"],["Chifferobe Home & Garden","Black Mountain","NC"],["Dearness Gardens","Huntersville","NC"],["Garden Supply Company","Cary","NC"],["The Garden Outlet","Summerfield","NC"],["Mulhall's","Omaha","NE"],["Wild Birds Unlimited","Somersworth","NH"],["Heart of the Home","Frenchtown","NJ"],["Plant World","Albuquerque","NM"],["Bayport Flower Houses","Bayport","NY"],["Kulak's Nursery & Landscaping","Rexford","NY"],["Baker's Village & Garden Center","Powell","OH"],["Burger Farm & Garden Center","Newtown","OH"],["Don Drumm Studios & Gallery","Akron","OH"],["Moyer's Nursery and Landscaping","Massillon","OH"],["Mulberry Creek Herb Farm","Huron","OH"],["Pipkin's Market","Cincinnati","OH"],["Wild Birds Unlimited","Columbus","OH"],["Lowe's Greenhouse","Chagrin Falls","OH"],["Taracotta Garden Outlet","Guthrie","OK"],["The Greenhouse","Norman","OK"],["Under the Sun Garden Center","Edmond","OK"],["Bird Alliance of Oregon Nature Store","Portland","OR"],["Dock No. 2 Design","Eugene","OR"],["Garland Nursery","Corvallis","OR"],["Moonfire and Sun Garden Center","Bend","OR"],["Purple Hen Flowers & Herbs","Sherwood","OR"],["Brick House Garden Center","Greeley","PA"],["Douglas Albert Gallery","State College","PA"],["Linvilla Orchards","Media","PA"],["Phipps Conservatory & Botanical Gardens","Pittsburgh","PA"],["Primex Garden Center","Glenside","PA"],["Quality Gardens","Valencia","PA"],["Wingards Nursery","Lexington","SC"],["Crossville Garden Center","Crossville","TN"],["Gardens of Babylon","Nashville","TN"],["Urban Earth","Memphis","TN"],["Blue Moon Gardens","Chandler","TX"],["Fred Reyes Greenhouses","Simonton","TX"],["Gardens at the Ridge","Kerrville","TX"],["Gruene Gardens","New Braunfels","TX"],["H & N Landscaping & Nursery","Texarkana","TX"],["Hill Country Water Gardens","Cedar Park","TX"],["Kingwood Garden Center","Kingwood","TX"],["Ruibal's Plants of Texas","Dallas","TX"],["The Enchanted Gardens","Richmond","TX"],["Tom's Thumb by Cornelius Nursery","Galveston","TX"],["Schmidt's Greenhouse","West Jordan","UT"],["Sun River Gardens","Orem","UT"],["Handworks Gallery","Winchester","VA"],["Strange's Garden Center","Richmond","VA"],["Yard Birds","Richmond","VA"],["Bainbridge Gardens","Bainbridge Island","WA"],["My Garden Nursery","Bellingham","WA"],["The Gray Barn Nursery","Redmond","WA"],["Wild Birds Unlimited","Olympia","WA"],["Eckles Pottery","Bayfield","WI"],["Hanson's Garden Village","Rhinelander","WI"],["Hudson Flower Shop","Hudson","WI"],["J & M Pottery","Pleasant Prairie","WI"],["Klinger Farm Market","Chippewa Falls","WI"],["Milaeger's","Racine","WI"],["Moraine Gardens","Plymouth","WI"],["Seasons from the Heart","Cedarburg","WI"],["Shady Acres Perennial Nursery","New Berlin","WI"],["The Potter's Shed","Shell Lake","WI"],["Winkler's Greenhouse","Boulder Junction","WI"]];

  // US city coordinates (city,ST -> [lat, lng])
  var CITY = {"Birmingham,AL":[33.52,-86.81],"Little Rock,AR":[34.75,-92.29],"Phoenix,AZ":[33.45,-112.07],"Queen Creek,AZ":[33.25,-111.63],"Tucson,AZ":[32.22,-110.97],"Ventura,CA":[34.27,-119.23],"American Canyon,CA":[38.17,-122.26],"Carmel-By-The-Sea,CA":[36.56,-121.92],"Loomis,CA":[38.82,-121.19],"Chico,CA":[39.73,-121.84],"Santa Monica,CA":[34.02,-118.49],"Rocklin,CA":[38.79,-121.24],"Fresno,CA":[36.74,-119.79],"El Cajon,CA":[32.79,-116.96],"Petaluma,CA":[38.23,-122.64],"Santa Barbara,CA":[34.42,-119.70],"Orange,CA":[33.79,-117.85],"San Diego,CA":[32.72,-117.16],"Oakland,CA":[37.80,-122.27],"San Francisco,CA":[37.77,-122.42],"San Rafael,CA":[37.97,-122.53],"Half Moon Bay,CA":[37.46,-122.43],"Denver,CO":[39.74,-104.99],"Arvada,CO":[39.80,-105.09],"Centennial,CO":[39.58,-104.88],"Windsor,CO":[40.48,-104.90],"Colorado Springs,CO":[38.83,-104.82],"Louisville,CO":[39.98,-105.13],"Mystic,CT":[41.35,-71.97],"Darien,CT":[41.05,-73.47],"Fort Myers,FL":[26.64,-81.87],"Mount Dora,FL":[28.80,-81.64],"Tavernier,FL":[25.01,-80.52],"Tallahassee,FL":[30.44,-84.28],"St. Petersburg,FL":[27.77,-82.64],"Atlanta,GA":[33.75,-84.39],"Savannah,GA":[32.08,-81.09],"Clarkesville,GA":[34.61,-83.52],"Saint Simons Island,GA":[31.15,-81.37],"Marion,IA":[42.03,-91.60],"Dubuque,IA":[42.50,-90.66],"Decorah,IA":[43.30,-91.79],"Oskaloosa,IA":[41.30,-92.64],"Cumming,IA":[41.48,-93.77],"Nampa,ID":[43.54,-116.56],"Jerome,ID":[42.72,-114.52],"Hayden,ID":[47.77,-116.79],"Idaho Falls,ID":[43.49,-112.03],"Chicago,IL":[41.88,-87.63],"Downers Grove,IL":[41.80,-88.01],"La Grange,IL":[41.80,-87.87],"Hillside,IL":[41.88,-87.90],"Champaign,IL":[40.12,-88.24],"Morris,IL":[41.36,-88.42],"Palos Park,IL":[41.67,-87.83],"Overland Park,KS":[38.98,-94.67],"Louisville,KY":[38.25,-85.76],"Bowling Green,KY":[36.99,-86.44],"Amherst,MA":[42.37,-72.52],"East Falmouth,MA":[41.57,-70.56],"Middletown,MD":[39.44,-77.55],"Ogunquit,ME":[43.25,-70.60],"Bangor,ME":[44.80,-68.77],"Fryeburg,ME":[44.02,-70.98],"Detroit,MI":[42.33,-83.05],"Suttons Bay,MI":[44.98,-85.65],"Allendale,MI":[42.97,-86.17],"Macomb,MI":[42.66,-82.91],"Clinton Township,MI":[42.59,-82.92],"Plymouth,MI":[42.37,-83.47],"Royal Oak,MI":[42.49,-83.14],"West Bloomfield,MI":[42.57,-83.38],"Dearborn Heights,MI":[42.34,-83.27],"Eastpointe,MI":[42.47,-82.96],"Shelby Twp,MI":[42.67,-83.03],"Holland,MI":[42.79,-86.11],"Empire,MI":[44.81,-86.06],"Petoskey,MI":[45.37,-84.96],"Rosemount,MN":[44.74,-93.13],"Minnetonka,MN":[44.92,-93.47],"Chanhassen,MN":[44.86,-93.53],"Minneapolis,MN":[44.98,-93.27],"Apple Valley,MN":[44.73,-93.22],"Stillwater,MN":[45.06,-92.81],"Red Wing,MN":[44.56,-92.53],"Waite Park,MN":[45.56,-94.22],"Kansas City,MO":[39.10,-94.58],"Warrensburg,MO":[38.76,-93.74],"Ellisville,MO":[38.59,-90.59],"Black Mountain,NC":[35.62,-82.32],"Huntersville,NC":[35.41,-80.84],"Cary,NC":[35.79,-78.78],"Summerfield,NC":[36.21,-79.90],"Omaha,NE":[41.26,-95.93],"Somersworth,NH":[43.26,-70.87],"Frenchtown,NJ":[40.53,-75.06],"Albuquerque,NM":[35.08,-106.65],"Bayport,NY":[40.74,-73.05],"Rexford,NY":[42.85,-73.87],"Powell,OH":[40.16,-83.08],"Newtown,OH":[39.13,-84.36],"Akron,OH":[41.08,-81.52],"Massillon,OH":[40.80,-81.52],"Huron,OH":[41.40,-82.56],"Cincinnati,OH":[39.10,-84.51],"Columbus,OH":[39.96,-82.10],"Chagrin Falls,OH":[41.43,-81.39],"Guthrie,OK":[35.88,-97.43],"Norman,OK":[35.22,-97.44],"Edmond,OK":[35.65,-97.48],"Portland,OR":[45.52,-122.68],"Eugene,OR":[44.05,-123.09],"Corvallis,OR":[44.56,-123.26],"Bend,OR":[44.06,-121.31],"Sherwood,OR":[45.36,-122.84],"Greeley,PA":[41.43,-75.07],"State College,PA":[40.79,-77.86],"Media,PA":[39.92,-75.39],"Pittsburgh,PA":[40.44,-79.10],"Glenside,PA":[40.10,-75.15],"Valencia,PA":[40.68,-80.09],"Lexington,SC":[33.98,-81.24],"Crossville,TN":[35.95,-85.03],"Nashville,TN":[36.16,-86.78],"Memphis,TN":[35.15,-90.05],"Chandler,TX":[32.31,-95.48],"Simonton,TX":[29.68,-95.10],"Kerrville,TX":[30.05,-99.14],"New Braunfels,TX":[29.70,-98.12],"Texarkana,TX":[33.43,-94.05],"Cedar Park,TX":[30.51,-97.82],"Kingwood,TX":[30.04,-95.26],"Dallas,TX":[32.78,-96.80],"Richmond,TX":[29.58,-95.76],"Galveston,TX":[29.30,-94.80],"West Jordan,UT":[40.61,-111.94],"Orem,UT":[40.30,-111.70],"Winchester,VA":[39.19,-78.17],"Richmond,VA":[37.54,-77.44],"Bainbridge Island,WA":[47.63,-122.52],"Bellingham,WA":[48.75,-122.48],"Redmond,WA":[47.67,-122.12],"Olympia,WA":[47.04,-122.90],"Bayfield,WI":[46.81,-90.82],"Rhinelander,WI":[45.64,-89.41],"Hudson,WI":[44.97,-92.76],"Pleasant Prairie,WI":[42.55,-87.93],"Chippewa Falls,WI":[44.94,-91.39],"Racine,WI":[42.73,-87.78],"Plymouth,WI":[43.75,-87.98],"Cedarburg,WI":[43.30,-87.99],"New Berlin,WI":[42.98,-88.11],"Shell Lake,WI":[45.74,-91.92],"Boulder Junction,WI":[46.09,-89.63],"Livonia,MI":[42.37,-83.35],"Southern California,CA":[34.05,-118.24]};

  // US state centers as fallback
  var ST = {"AL":[32.81,-86.79],"AK":[61.37,-152.40],"AZ":[33.73,-111.43],"AR":[34.97,-92.37],"CA":[36.12,-119.68],"CO":[39.06,-105.31],"CT":[41.60,-72.76],"DE":[39.32,-75.51],"FL":[27.77,-81.69],"GA":[33.04,-83.64],"HI":[21.09,-157.50],"ID":[44.24,-114.48],"IL":[40.35,-88.99],"IN":[39.85,-86.26],"IA":[42.01,-93.21],"KS":[38.53,-96.73],"KY":[37.67,-84.67],"LA":[31.17,-91.87],"ME":[44.69,-69.38],"MD":[39.06,-76.80],"MA":[42.23,-71.53],"MI":[43.33,-84.54],"MN":[45.69,-93.90],"MS":[32.74,-89.68],"MO":[38.46,-92.29],"MT":[46.92,-110.45],"NE":[41.13,-98.27],"NV":[38.31,-117.06],"NH":[43.45,-71.56],"NJ":[40.30,-74.52],"NM":[34.84,-106.25],"NY":[42.17,-74.95],"NC":[35.63,-79.81],"ND":[47.53,-99.78],"OH":[40.39,-82.76],"OK":[35.57,-96.93],"OR":[44.57,-122.07],"PA":[40.59,-77.21],"RI":[41.68,-71.51],"SC":[33.86,-80.95],"SD":[44.30,-99.44],"TN":[35.75,-86.69],"TX":[31.05,-97.56],"UT":[40.15,-111.86],"VT":[44.05,-72.71],"VA":[37.77,-78.17],"WA":[47.40,-121.49],"WV":[38.49,-80.95],"WI":[44.27,-89.62],"WY":[42.76,-107.30]};

  var STATE_NAMES = {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"};

  // Build retailers with coordinates
  var retailers = RAW.map(function (r) {
    var name = r[0], city = r[1], state = r[2];
    var key = city + ',' + state;
    var coords = CITY[key] || ST[state] || null;
    return { name: name, city: city, state: state, stateName: STATE_NAMES[state] || state, lat: coords ? coords[0] : null, lng: coords ? coords[1] : null };
  }).filter(function (r) { return r.lat !== null; });

  // Haversine distance in miles
  function distanceMi(lat1, lng1, lat2, lng2) {
    var R = 3959;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // Wait for DOM and Leaflet
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForLeaflet);
  } else {
    waitForLeaflet();
  }

  function waitForLeaflet() {
    if (typeof L !== 'undefined') { init(); return; }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (typeof L !== 'undefined') { clearInterval(timer); init(); }
      else if (attempts > 50) { clearInterval(timer); }
    }, 100);
  }

  function init() {
    var mapEl = document.getElementById('retailer-map');
    var listEl = document.getElementById('retailer-list');
    var searchEl = document.getElementById('retailer-search');
    var clearEl = document.getElementById('retailer-clear');
    var countEl = document.getElementById('retailer-count');

    if (!mapEl) return;

    // Init map
    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([39.83, -98.58], 4);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '&copy; <a href="https://carto.com/">CARTO</a>',
      maxZoom: 18,
    }).addTo(map);
    map.once('click', function () { map.scrollWheelZoom.enable(); });

    // Create markers
    var markers = [];
    retailers.forEach(function (r) {
      var marker = L.circleMarker([r.lat, r.lng], {
        radius: 6, fillColor: '#1a1a1a', color: '#fff', weight: 1.5, fillOpacity: 0.8,
      });
      marker.bindPopup('<strong>' + esc(r.name) + '</strong><p>' + esc(r.city) + ', ' + r.state + '</p>');
      marker.retailer = r;
      markers.push(marker);
    });
    var markerGroup = L.layerGroup(markers).addTo(map);

    // User location marker
    var userMarker = null;

    // Autocomplete dropdown
    var suggestBox = document.createElement('div');
    suggestBox.className = 'store-locator__suggestions';
    suggestBox.style.cssText = 'position:absolute;top:100%;left:0;right:0;background:#fff;border:1px solid rgba(0,0,0,0.12);border-top:none;border-radius:0 0 8px 8px;max-height:220px;overflow-y:auto;z-index:1000;display:none;box-shadow:0 4px 12px rgba(0,0,0,0.1);';
    searchEl.parentNode.appendChild(suggestBox);

    var fetchTimer = null;
    var activeSuggestion = -1;

    // Nominatim geocode search
    function nominatimSearch(query) {
      var url = 'https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&limit=5&q=' + encodeURIComponent(query);
      return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    function showSuggestions(results) {
      suggestBox.innerHTML = '';
      activeSuggestion = -1;
      if (!results || results.length === 0) {
        suggestBox.style.display = 'none';
        return;
      }
      results.forEach(function (place, i) {
        var item = document.createElement('div');
        item.style.cssText = 'padding:0.6rem 1rem;cursor:pointer;font-size:0.88rem;border-bottom:1px solid rgba(0,0,0,0.04);';
        item.textContent = place.display_name;
        item.addEventListener('mouseenter', function () {
          item.style.background = 'rgba(0,0,0,0.04)';
        });
        item.addEventListener('mouseleave', function () {
          item.style.background = 'none';
        });
        item.addEventListener('mousedown', function (e) {
          e.preventDefault(); // prevent blur
          selectPlace(place);
        });
        suggestBox.appendChild(item);
      });
      suggestBox.style.display = 'block';
    }

    function selectPlace(place) {
      var lat = parseFloat(place.lat);
      var lng = parseFloat(place.lon);

      // Update search input with short display name
      var shortName = place.display_name.split(',').slice(0, 3).join(',');
      searchEl.value = shortName;
      suggestBox.style.display = 'none';
      clearEl.style.display = 'block';

      // Show user location marker
      if (userMarker) map.removeLayer(userMarker);
      userMarker = L.marker([lat, lng], {
        icon: L.divIcon({
          className: 'store-locator__user-pin',
          html: '<svg width="24" height="24" viewBox="0 0 24 24" fill="#c0392b" stroke="#fff" stroke-width="1.5"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>',
          iconSize: [24, 24],
          iconAnchor: [12, 24],
        })
      }).addTo(map).bindPopup('<strong>Your location</strong>');

      // Sort retailers by distance
      var sorted = retailers.map(function (r) {
        return { retailer: r, distance: distanceMi(lat, lng, r.lat, r.lng) };
      }).sort(function (a, b) { return a.distance - b.distance; });

      // Show nearest 20 within 200 miles, or at least nearest 5
      var nearby = sorted.filter(function (s) { return s.distance <= 200; });
      if (nearby.length < 5) nearby = sorted.slice(0, 5);
      if (nearby.length > 20) nearby = nearby.slice(0, 20);

      // Update markers
      markerGroup.clearLayers();
      var bounds = [[lat, lng]];
      nearby.forEach(function (s) {
        markers.forEach(function (m) {
          if (m.retailer === s.retailer) {
            // Update popup with distance
            m.setPopupContent('<strong>' + esc(s.retailer.name) + '</strong><p>' + esc(s.retailer.city) + ', ' + s.retailer.state + '</p><p style="color:#c0392b;font-weight:600;">' + Math.round(s.distance) + ' miles away</p>');
            markerGroup.addLayer(m);
            bounds.push([s.retailer.lat, s.retailer.lng]);
          }
        });
      });

      // Fit map to show user + retailers
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 10 });

      // Render list sorted by distance
      renderNearby(nearby);
    }

    function renderNearby(nearby) {
      listEl.innerHTML = '';
      if (nearby.length === 0) {
        listEl.innerHTML = '<div class="store-locator__empty">No retailers found nearby.</div>';
        countEl.textContent = '';
        return;
      }

      nearby.forEach(function (s) {
        var r = s.retailer;
        var card = document.createElement('div');
        card.className = 'store-locator__card';
        card.innerHTML = '<div class="store-locator__card-name">' + esc(r.name) + '</div>' +
          '<div class="store-locator__card-location">' + esc(r.city) + ', ' + r.state +
          ' &middot; <strong>' + Math.round(s.distance) + ' mi</strong></div>';
        card.addEventListener('click', function () {
          map.setView([r.lat, r.lng], 12);
          markers.forEach(function (m) { if (m.retailer === r) m.openPopup(); });
        });
        listEl.appendChild(card);
      });

      countEl.textContent = nearby.length + ' retailer' + (nearby.length === 1 ? '' : 's') + ' near you';
    }

    // Render full list grouped by state (default view)
    function renderAll() {
      listEl.innerHTML = '';
      var grouped = {};
      retailers.forEach(function (r) {
        if (!grouped[r.state]) grouped[r.state] = [];
        grouped[r.state].push(r);
      });

      var stateKeys = Object.keys(grouped).sort();
      stateKeys.forEach(function (st) {
        var header = document.createElement('div');
        header.style.cssText = 'padding:0.6rem 1rem 0.3rem;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.08em;color:rgba(0,0,0,0.35);font-weight:600;border-bottom:1px solid rgba(0,0,0,0.05);position:sticky;top:0;background:rgb(var(--color-background,255,255,255));z-index:1;';
        header.textContent = STATE_NAMES[st] || st;
        listEl.appendChild(header);

        grouped[st].forEach(function (r) {
          var card = document.createElement('div');
          card.className = 'store-locator__card';
          card.innerHTML = '<div class="store-locator__card-name">' + esc(r.name) + '</div><div class="store-locator__card-location">' + esc(r.city) + ', ' + r.state + '</div>';
          card.addEventListener('click', function () {
            map.setView([r.lat, r.lng], 10);
            markers.forEach(function (m) { if (m.retailer === r) m.openPopup(); });
          });
          listEl.appendChild(card);
        });
      });

      countEl.textContent = retailers.length + ' retailers across ' + stateKeys.length + ' states';
    }

    // Reset to full view
    function resetView() {
      if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
      markerGroup.clearLayers();
      markers.forEach(function (m) {
        // Reset popup to original
        var r = m.retailer;
        m.setPopupContent('<strong>' + esc(r.name) + '</strong><p>' + esc(r.city) + ', ' + r.state + '</p>');
        markerGroup.addLayer(m);
      });
      map.setView([39.83, -98.58], 4);
      renderAll();
    }

    // Search input handlers
    searchEl.addEventListener('input', function () {
      var q = searchEl.value.trim();
      clearEl.style.display = q ? 'block' : 'none';

      if (!q) {
        suggestBox.style.display = 'none';
        resetView();
        return;
      }

      // Also do instant text filtering on retailer names/cities
      var textMatch = retailers.filter(function (r) {
        var lower = q.toLowerCase();
        return r.name.toLowerCase().indexOf(lower) !== -1 ||
          r.city.toLowerCase().indexOf(lower) !== -1 ||
          r.state.toLowerCase() === lower ||
          (r.stateName && r.stateName.toLowerCase().indexOf(lower) !== -1);
      });

      if (textMatch.length > 0) {
        // Show text matches immediately
        suggestBox.style.display = 'none';
        markerGroup.clearLayers();
        if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
        var bounds = [];
        textMatch.forEach(function (r) {
          markers.forEach(function (m) {
            if (m.retailer === r) {
              m.setPopupContent('<strong>' + esc(r.name) + '</strong><p>' + esc(r.city) + ', ' + r.state + '</p>');
              markerGroup.addLayer(m);
              bounds.push([r.lat, r.lng]);
            }
          });
        });
        if (bounds.length === 1) map.setView(bounds[0], 10);
        else if (bounds.length > 1) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 8 });

        // Render as grouped list
        listEl.innerHTML = '';
        var grouped = {};
        textMatch.forEach(function (r) {
          if (!grouped[r.state]) grouped[r.state] = [];
          grouped[r.state].push(r);
        });
        var stateKeys = Object.keys(grouped).sort();
        stateKeys.forEach(function (st) {
          var header = document.createElement('div');
          header.style.cssText = 'padding:0.6rem 1rem 0.3rem;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.08em;color:rgba(0,0,0,0.35);font-weight:600;border-bottom:1px solid rgba(0,0,0,0.05);position:sticky;top:0;background:rgb(var(--color-background,255,255,255));z-index:1;';
          header.textContent = STATE_NAMES[st] || st;
          listEl.appendChild(header);
          grouped[st].forEach(function (r) {
            var card = document.createElement('div');
            card.className = 'store-locator__card';
            card.innerHTML = '<div class="store-locator__card-name">' + esc(r.name) + '</div><div class="store-locator__card-location">' + esc(r.city) + ', ' + r.state + '</div>';
            card.addEventListener('click', function () {
              map.setView([r.lat, r.lng], 10);
              markers.forEach(function (m) { if (m.retailer === r) m.openPopup(); });
            });
            listEl.appendChild(card);
          });
        });
        countEl.textContent = textMatch.length + ' retailer' + (textMatch.length === 1 ? '' : 's') + ' found';
      }

      // Geocode with Nominatim (debounced) for location-based search
      clearTimeout(fetchTimer);
      if (q.length >= 3) {
        fetchTimer = setTimeout(function () {
          nominatimSearch(q).then(showSuggestions).catch(function () {
            suggestBox.style.display = 'none';
          });
        }, 400);
      }
    });

    // Keyboard navigation for suggestions
    searchEl.addEventListener('keydown', function (e) {
      var items = suggestBox.querySelectorAll('div');
      if (!items.length || suggestBox.style.display === 'none') return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeSuggestion = Math.min(activeSuggestion + 1, items.length - 1);
        items.forEach(function (el, i) { el.style.background = i === activeSuggestion ? 'rgba(0,0,0,0.04)' : 'none'; });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeSuggestion = Math.max(activeSuggestion - 1, 0);
        items.forEach(function (el, i) { el.style.background = i === activeSuggestion ? 'rgba(0,0,0,0.04)' : 'none'; });
      } else if (e.key === 'Enter' && activeSuggestion >= 0) {
        e.preventDefault();
        items[activeSuggestion].dispatchEvent(new MouseEvent('mousedown'));
      } else if (e.key === 'Escape') {
        suggestBox.style.display = 'none';
      }
    });

    // Hide suggestions on blur
    searchEl.addEventListener('blur', function () {
      setTimeout(function () { suggestBox.style.display = 'none'; }, 200);
    });

    clearEl.addEventListener('click', function () {
      searchEl.value = '';
      clearEl.style.display = 'none';
      suggestBox.style.display = 'none';
      resetView();
      searchEl.focus();
    });

    // Initial render — show all retailers
    renderAll();
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
})();
